<template>
    <div class="p-3 pt-0 pb-0">
        <patient-history-tabs :userId="userId" :consId="consId"></patient-history-tabs>
    </div>
</template>
<script>
import patientHistoryTabs from '@/components/clients/history/patient-history-tabs.vue'
export default {    
    name: "history",
    props: ['userId', 'consId'],
    components: {   
        patientHistoryTabs
    },
    data(){
        return{
        }
    }
}
</script>